/**
 * Takes an object and a mapper and maps the key-value pair
 * @param {Object} obj
 * @param {Function} mapper - takes 2 arguments - value (and key) and returns the mapped value
 * @return {Object} object with mapped values
 */
export const objectMap = (obj, mapper) => {
  const result = {}
  Object.keys(obj).forEach(key => {
    result[key] = mapper(obj[key], key)
  })
  return result
}
